/* eslint react/forbid-prop-types: 0 */
import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { Glyphicon, Popover, OverlayTrigger, Table } from "react-bootstrap";
import RunsheetStatus from "./RunsheetStatus";
import CancelAction from "./RunsheetCancel";
import {
  cancelRunsheet,
  allocateRunsheet,
  updateVehicle,
  removeVehicle
} from "../../../actions/runsheets";
import AssociateAction from "./actions/AssociateAction";

const StatusIcon = ({ status }) => {
  switch (status) {
    case "OPENED":
      return <span className="bluedot" title="Opened" />;
    case "IN_PROGRESS":
      return (
        <span className="sprite-image inprogress-image" title="In Progress" />
      );
    case "COMPLETED":
      return (
        <span className="completed-icon" title="Completed">
          <Glyphicon glyph="ok" />
        </span>
      );
    case "CANCELLED":
      return (
        <span className="cancelled-icon" title="Cancelled">
          <Glyphicon glyph="remove" />
        </span>
      );
    default:
      return <span className="greendot" title="Created" />;
  }
};
StatusIcon.propTypes = {
  status: PropTypes.string
};
StatusIcon.defaultProps = {
  status: ""
};

const CopyLink = ({ id }) => (
  <Link className="custom-link" to={`runsheets/${id}/copy`} title="Copy">
    <Glyphicon glyph="duplicate" />
  </Link>
);
CopyLink.propTypes = {
  id: PropTypes.number.isRequired
};

const RunsheetPopover = props => {
  const { runsheet } = props;

  const getActions = () => {
    switch (runsheet.status) {
      case "CREATED":
        return (
          <ul className="list-inline">
            <li>
              <Link
                className="custom-link"
                to={`/runsheets/${runsheet.id}`}
                title="View"
              >
                <Glyphicon glyph="eye-open" />
              </Link>
            </li>
            <li>
              <Link
                className="custom-link"
                to={`/runsheets/${runsheet.id}/edit`}
                title="Edit"
              >
                <Glyphicon glyph="pencil" />
              </Link>
            </li>
            <li>
              <CopyLink id={runsheet.id} />
            </li>
            <li>
              <AssociateAction
                runsheet={runsheet}
                allocateRunsheet={props.allocateRunsheet}
                updateVehicle={props.updateVehicle}
                removeVehicle={props.removeVehicle}
              />
            </li>
            <li>
              <CancelAction
                runsheet={runsheet}
                cancelRunsheet={props.cancelRunsheet}
              />
            </li>
          </ul>
        );
      default:
        return (
          <ul className="list-inline">
            <li>
              <Link
                className="custom-link"
                to={`/runsheets/${runsheet.id}`}
                title="View"
              >
                <Glyphicon glyph="eye-open" />
              </Link>
            </li>
          </ul>
        );
    }
  };

  const actions = getActions();
  const popoverProps = { ...props };
  delete popoverProps.cancelRunsheet;
  delete popoverProps.allocateRunsheet;
  delete popoverProps.updateVehicle;
  delete popoverProps.removeVehicle;

  return (
    <Popover
      {...popoverProps}
      id="popover-positioned-bottom"
      title={runsheet.externalId}
      className="runsheet-popover"
    >
      <Table className="event-detail-table" bordered striped>
        <tbody>
          <tr>
            <td>ID</td>
            <td>{runsheet.externalId}</td>
          </tr>
          <tr>
            <td>Name</td>
            <td>{runsheet.name}</td>
          </tr>
          <tr>
            <td>Status</td>
            <td>
              <RunsheetStatus status={runsheet.status} jobs={runsheet.jobs} />
            </td>
          </tr>
          <tr>
            <td>Vehicle</td>
            <td>{runsheet.vehicle ? runsheet.vehicle.name : ""}</td>
          </tr>
          <tr>
            <td>Jobs</td>
            <td>{runsheet.jobs.length}</td>
          </tr>
          <tr>
            <td>Actions</td>
            <td>{actions}</td>
          </tr>
        </tbody>
      </Table>
    </Popover>
  );
};
RunsheetPopover.propTypes = {
  runsheet: PropTypes.object.isRequired,
  cancelRunsheet: PropTypes.func.isRequired,
  allocateRunsheet: PropTypes.func.isRequired,
  updateVehicle: PropTypes.func.isRequired,
  removeVehicle: PropTypes.func.isRequired
};

const RunsheetCalendarEvent = props => {
  const runsheet = props.event;

  return (
    <OverlayTrigger
      trigger="click"
      rootClose={false}
      placement="bottom"
      overlay={
        <RunsheetPopover
          runsheet={runsheet}
          cancelRunsheet={props.cancelRunsheet}
          allocateRunsheet={props.allocateRunsheet}
          updateVehicle={props.updateVehicle}
          removeVehicle={props.removeVehicle}
        />
      }
    >
      <div>
        <div style={{ display: "flex" }}>
          <div>
            <StatusIcon status={runsheet.status} />
          </div>
          <div>
            <div className="bold-text">
              {runsheet.name} {runsheet.externalId || ""}
            </div>
            {runsheet.vehicle ? <span>{runsheet.vehicle.name}</span> : ""}
          </div>
        </div>
      </div>
    </OverlayTrigger>
  );
};
RunsheetCalendarEvent.propTypes = {
  event: PropTypes.object.isRequired,
  cancelRunsheet: PropTypes.func.isRequired,
  allocateRunsheet: PropTypes.func.isRequired,
  updateVehicle: PropTypes.func.isRequired,
  removeVehicle: PropTypes.func.isRequired
};

const mapStateToProps = () => ({});
const mapDispatchToProps = {
  cancelRunsheet,
  allocateRunsheet,
  updateVehicle,
  removeVehicle
};

export default connect(mapStateToProps, mapDispatchToProps)(
  RunsheetCalendarEvent
);



// WEBPACK FOOTER //
// ./src/components/runsheets/list/RunsheetCalendarEvent.js